export default {
  // ── Navigation ──────────────────────────────────────────────────────────────
  'nav.dashboard':         'Dashboard',
  'nav.leads':             'Leads',
  'nav.filters':           'Filters',
  'nav.filters/keywords':  'Keywords',
  'nav.filters/prompts':   'AI Prompts',
  'nav.groups':            'Groups',
  'nav.history':           'Sweep History',
  'nav.settings':          'Settings',
  'nav.users':             'Users',

  // ── Sidebar status ──────────────────────────────────────────────────────────
  'sidebar.sweeping':  'Sweeping…',
  'sidebar.running':   'Running',
  'sidebar.paused':    'Paused',
  'sidebar.runSweep':  'Run Sweep',
  'sidebar.logout':    'Logout',

  // ── Sweep modal ─────────────────────────────────────────────────────────────
  'sweep.title':              '⚡ Run Sweep',
  'sweep.subtitle':           'Choose how far back to look',
  'sweep.last_sweep.label':   'Since last sweep',
  'sweep.last_sweep.sub':     'Only new posts since previous run',
  'sweep.last_day.label':     'Last 24 hours',
  'sweep.last_day.sub':       'Posts from the past day',
  'sweep.last_3_days.label':  'Last 3 days',
  'sweep.last_3_days.sub':    'Posts from the past 3 days',
  'sweep.amount.label':       'By post count',
  'sweep.amount.sub':         'Scrape a fixed number of recent posts',
  'sweep.postsPerGroup':      'Number of posts per group',
  'sweep.postsPlaceholder':   'e.g. 50',
  'sweep.run':                '⚡ Run Sweep',
  'sweep.cancel':             'Cancel',

  // ── Time range ──────────────────────────────────────────────────────────────
  'time.24h':  'Last 24h',
  'time.7d':   'Last 7d',
  'time.30d':  'Last 30d',
  'time.all':  'All time',

  // ── Shared primitives ───────────────────────────────────────────────────────
  'loading':           'Loading…',
  'add':               '+ Add',
  'save':              'Save',
  'cancel':            'Cancel',
  'delete':            'Delete',
  'edit':              '✏️ Edit',
  'saving':            'Saving…',
  'copied':            'Copied!',
  'apiNotice':         'API not connected — showing defaults.',
  'goToPost':          'Go to Post',
  'relevant.title':    'Relevant',
  'notRelevant.title': 'Not relevant',

  // ── Dashboard ───────────────────────────────────────────────────────────────
  'dashboard.title':           'Dashboard',
  'dashboard.subtitle':        'Real-time lead intelligence from Facebook groups',
  'dashboard.postsScanned':    'Posts Scanned',
  'dashboard.qualifiedLeads':  'Qualified Leads',
  'dashboard.pendingSend':     'Pending Send',
  'dashboard.sentToday':       'Sent Today',
  'dashboard.aiCosts':         'AI Costs',
  'dashboard.avgScore':        'Avg Score',
  'dashboard.scoreBreakdown':  'Score Breakdown',
  'dashboard.relevanceFeedback': 'Relevance Feedback',
  'dashboard.assignmentOverview': 'Assignment Overview',
  'dashboard.quickStats':      'Quick Stats',
  'dashboard.recentLeads':     'Recent Leads',
  'dashboard.scoreHigh':       '🟢 High 80+',
  'dashboard.scoreMid':        '🟡 Mid 65–79',
  'dashboard.scoreLow':        '⚪ Low <65',
  'dashboard.noScoreData':     'No score data yet',
  'dashboard.relevant':        '👍 Relevant',
  'dashboard.notRelevant':     '👎 Not Relevant',
  'dashboard.untagged':        '❓ Untagged',
  'dashboard.positiveRate':    'Positive rate:',
  'dashboard.needsReview':     '{n} leads still need your review',
  'dashboard.unassigned':      'Unassigned',
  'dashboard.assigned':        'Assigned',
  'dashboard.noLeadsAssigned': 'No leads assigned yet',
  'dashboard.scoreHighFull':   '🟢 High Score (80+)',
  'dashboard.scoreMidFull':    '🟡 Mid Score (65–79)',
  'dashboard.sentTodayFull':   '📤 Sent Today',
  'dashboard.pendingSendFull': '📋 Pending Send',
  'dashboard.noLeads':         'No leads yet — run a sweep to start collecting',

  // ── Table column headers ────────────────────────────────────────────────────
  'col.score':      'Score',
  'col.author':     'Author',
  'col.group':      'Group',
  'col.date':       'Date',
  'col.status':     'Status',
  'col.type':       'Type',
  'col.preview':    'Preview',
  'col.relevant':   'Relevant',
  'col.keyword':    'Keyword',
  'col.category':   'Category',
  'col.blocked':    'Blocked',
  'col.posts':      'Posts',
  'col.signal':     'Signal',
  'col.created':    'Created',
  'col.active':     'Active',
  'col.email':      'Email',
  'col.name':       'Name',
  'col.phone':      'Phone',
  'col.role':       'Role',
  'col.lastLogin':  'Last Login',
  'col.started':    'Started',
  'col.duration':   'Duration',
  'col.triggered':  'Triggered',
  'col.postsSeen':  'Posts Seen',
  'col.matched':    'Matched',
  'col.scored':     'Scored',
  'col.newLeads':   'New Leads',
  'col.aiCost':     'AI Cost',

  // ── Lead detail labels ──────────────────────────────────────────────────────
  'lead.sent':             '✓ Sent',
  'lead.pending':          'Pending',
  'lead.comment':          '💬 Comment',
  'lead.post':             '📝 Post',
  'lead.fullComment':      '💬 Full Comment',
  'lead.fullPost':         '📝 Full Post',
  'lead.aiContext':        '💡 AI Context',
  'lead.pitchDraft':       '✉️ Pitch Draft',
  'lead.matchedKeywords':  '🔑 Matched Keywords',
  'lead.aiPrompt':         '✦ AI Prompt',
  'lead.context':          '💡 Context',
  'lead.viewMore':         '▼ View more',
  'lead.viewLess':         '▲ View less',

  // ── Leads tab ───────────────────────────────────────────────────────────────
  'leads.title':           'Leads',
  'leads.subtitle':        '{n} leads',
  'leads.exportCsv':       '⬇ Export CSV',
  'leads.viewList':        '☰ List',
  'leads.viewGrid':        '⊞ Cards',
  'leads.filterTimeframe': 'Timeframe',
  'leads.filterMinScore':  'Min Score',
  'leads.filterRelevance': 'Relevance',
  'leads.filterSort':      'Sort',
  'leads.filterAssignedTo':'Assigned to',
  'leads.all':             'All',
  'leads.unassigned':      'Unassigned',
  'leads.relevant':        '👍 Relevant',
  'leads.notRelevant':     '👎 Not Relevant',
  'leads.untagged':        '❓ Untagged',
  'leads.newestFirst':     'Newest first',
  'leads.oldestFirst':     'Oldest first',
  'leads.assign':          '👤 Assign:',
  'leads.unassignedOption':'— Unassigned —',
  'leads.noLeads':         'No leads yet — run a sweep to start collecting',
  'leads.noExport':        'No leads to export',
  'leads.exported':        'Exported {n} leads',
  'leads.assignedTo':      'Assigned to {email}',
  'leads.unassignedDone':  'Unassigned',
  'leads.failedAssign':    'Failed: {msg}',
  'leads.failedUpdate':    'Failed to update: {msg}',

  // ── CSV headers ─────────────────────────────────────────────────────────────
  'csv.author':          'Author',
  'csv.group':           'Group',
  'csv.score':           'Score',
  'csv.date':            'Date',
  'csv.matchedKeywords': 'Matched Keywords',
  'csv.aiContext':       'AI Context',
  'csv.pitchDraft':      'Pitch Draft',
  'csv.relevant':        'Relevant',
  'csv.alertSent':       'Alert Sent',
  'csv.postUrl':         'Post URL',
  'csv.yes':             'Yes',
  'csv.no':              'No',
  'csv.untagged':        'Untagged',

  // ── Keywords ────────────────────────────────────────────────────────────────
  'keywords.title':             'Keywords',
  'keywords.subtitleInclude':   'Posts matching at least one include keyword are sent to scoring',
  'keywords.subtitleExclude':   'Posts matching any exclude keyword are dropped before scoring',
  'keywords.tabInclude':        'Include',
  'keywords.tabExclude':        'Exclude',
  'keywords.searchGuide':       'Search Guide',
  'keywords.guideExact':        'Exact phrase',
  'keywords.guideBoth':         'Both words',
  'keywords.guideStem':         'Word stem',
  'keywords.guideExactResult':  'Only exact matches',
  'keywords.guideBothResult':   'Both words anywhere',
  'keywords.guideStemResult':   'All word forms',
  'keywords.searchPlaceholder': 'Search keywords',
  'keywords.allOn':             '⏻ All On',
  'keywords.allOff':            '⏻ All Off',
  'keywords.recalibrate':       '⟳ Recalibrate',
  'keywords.recalibrating':     '…',
  'keywords.placeholderInclude':'New keyword (e.g. מחפש+כלי)',
  'keywords.placeholderExclude':'Exclude pattern (e.g. דרוש )',
  'keywords.emptyInclude':      'No keywords yet — add one above',
  'keywords.emptyExclude':      'No exclude keywords yet — add one above',
  'keywords.added':             'Keyword added!',
  'keywords.excludeAdded':      'Exclude keyword added!',
  'keywords.deleted':           'Keyword deleted',
  'keywords.recalibratedMsg':   'Signal data recalibrated — {n} keyword{s} with data',

  // ── AI Prompts ──────────────────────────────────────────────────────────────
  'prompts.title':               'AI Prompts',
  'prompts.subtitle':            "Guide Claude's scoring judgment — only one prompt can be active at a time",
  'prompts.anthropicTitle':      'Anthropic API Connection',
  'prompts.anthropicSubtitle':   'Connect your Anthropic account to enable AI-powered lead scoring',
  'prompts.connected':           '✓ Connected',
  'prompts.notConnected':        'Not connected',
  'prompts.currentKey':          'Current key:',
  'prompts.updateApiKey':        'Update API Key',
  'prompts.apiKey':              'API Key',
  'prompts.saveKey':             'Save Key',
  'prompts.model':               'Model',
  'prompts.scoringTitle':        'Scoring Prompts',
  'prompts.activePrompt':        'Active: {name}',
  'prompts.noActivePrompt':      'No prompt active — keyword-only mode',
  'prompts.active':              'ACTIVE',
  'prompts.on':                  'On',
  'prompts.off':                 'Off',
  'prompts.newPromptPlaceholder':'Prompt name',
  'prompts.promptTextPlaceholder':'Write scoring instructions for Claude...',
  'prompts.savePlus':            '+ Save',
  'prompts.addNew':              '+ New Prompt',
  'prompts.saved':               'Anthropic config saved!',
  'prompts.updated':             'Prompt updated',
  'prompts.deleted':             'Prompt deleted',
  'prompts.created':             'Prompt created',
  'prompts.recommended':         'Recommended',
  'prompts.fastest':             'Fastest',
  'prompts.copyKey':             'Copy key',
  'prompts.hideKey':             'Hide key',
  'prompts.showKey':             'Show key',
  'prompts.failedReveal':        'Failed to reveal key',
  'prompts.failedCopy':          'Failed to copy key',

  // ── Groups ──────────────────────────────────────────────────────────────────
  'groups.title':              'Facebook Groups',
  'groups.subtitle':           'Manage which groups Lead Radar scans on each sweep',
  'groups.fbNotConnected':     'Facebook not connected',
  'groups.fbNotConnectedDesc': 'Click to open a browser and log in to Facebook. The session is saved and reused on all future sweeps.',
  'groups.waitingForLogin':    'Waiting for login…',
  'groups.connectFacebook':    '🔗 Connect Facebook',
  'groups.sessionActive':      'Facebook session active',
  'groups.activeGroups':       'Active Groups',
  'groups.activePaused':       '{active} active · {paused} paused',
  'groups.noGroups':           'No groups added yet',
  'groups.openLink':           '↗ Open',
  'groups.addNew':             '+ Add New Group',
  'groups.addNewSub':          'Paste a Facebook group URL to start scanning it',
  'groups.labelPlaceholder':   'Label',
  'groups.urlPlaceholder':     'https://www.facebook.com/groups/...',
  'groups.addButton':          '+ Add Group',
  'groups.removed':            'Group removed',
  'groups.added':              'Group added!',
  'groups.invalidUrl':         'Invalid Facebook group URL',
  'groups.loginOpening':       'Opening Facebook login browser — log in and the window will close automatically.',
  'groups.sessionSaved':       'Facebook session saved!',
  'groups.loginTimeout':       'Login timed out',
  'groups.scraperError':       'Could not reach scraper',

  // ── Settings ────────────────────────────────────────────────────────────────
  'settings.title':               'Settings',
  'settings.subtitle':            'Configure sweep timing, notifications, and daily reports',
  'settings.sweepScheduling':     '⏱ Sweep Scheduling',
  'settings.sweepSchedulingSub':  'How often Lead Radar scans Facebook groups',
  'settings.schedulerEnabled':    '🟢 Automatic Sweeps Enabled',
  'settings.schedulerDisabled':   '⏸ Automatic Sweeps Disabled',
  'settings.schedulerEnabledDesc':'Lead Radar will scan groups automatically on the schedule below',
  'settings.schedulerDisabledDesc':'Scheduler is paused — use the Run Sweep button to scan manually',
  'settings.scanEvery':           'Scan every',
  'settings.every':               'Every',
  'settings.minutes':             'minutes',
  'settings.hours':               'hours',
  'settings.days':                'days',
  'settings.sweepScope':          '🔭 Auto Sweep Scope',
  'settings.sweepScopeSub':       'How far back each scheduled sweep looks',
  'settings.postsPerGroup':       'Posts per group',
  'settings.instantAlerts':       '⚡ Instant Alerts',
  'settings.instantAlertsSub':    'Triggered immediately when a post scores above the threshold',
  'settings.scoreThreshold':      'Score Threshold',
  'settings.alertWhenScore':      'Send instant alert when score ≥ {threshold}',
  'settings.sendTestEmail':       '📧 Send Test Email',
  'settings.sendUnsent':          '📤 Send Unsent Alerts',
  'settings.sendUnsentDesc':      'Send alerts for all leads above threshold that were not yet emailed',
  'settings.dailyReport':         '📋 Daily Report',
  'settings.dailyReportSub':      'A ranked digest of all leads sent once per day',
  'settings.sendTime':            'Send Time',
  'settings.next':                'Next:',
  'settings.reportRecipients':    'Report Recipients',
  'settings.aiOutputLang':        '🌐 AI Output Language',
  'settings.aiOutputLangSub':     'Language for AI-generated context and pitch text',
  'settings.saveAll':             '💾 Save All Settings',
  'settings.changePassword':      '🔑 Change Password',
  'settings.changePasswordSub':   'Update your login password',
  'settings.currentPassword':     'Current password',
  'settings.newPassword':         'New password',
  'settings.confirmPassword':     'Confirm new password',
  'settings.passwordHint':        'Min 10 characters · 1 uppercase letter · 1 number',
  'settings.updatePassword':      'Update Password',
  'settings.saved':               '✅ Settings saved!',
  'settings.savedLocally':        'Saved locally — API not connected',
  'settings.fillBothFields':      'Fill in both fields',
  'settings.passwordMismatch':    'New passwords do not match',
  'settings.passwordChanged':     'Password changed successfully',
  'settings.passwordChangeFailed':'Failed to change password',
  'settings.emailAddresses':      '📧 Email addresses',
  'settings.noEmails':            'No emails added yet',
  'settings.invalidEmail':        'Invalid email',
  'settings.emailAlreadyAdded':   'Already added',
  'settings.emailAdded':          'Email added!',
  'settings.emailPlaceholder':    'name@company.com',
  'settings.langHebrew':          '🇮🇱 Hebrew',
  'settings.langEnglish':         '🇬🇧 English',
  'settings.langPolish':          '🇵🇱 Polish',
  'settings.testEmailSent':       'Test email sent to {recipients}',
  'settings.unsentAlertsSent':    'Sent {n} unsent alert{s} (threshold ≥{threshold})',

  // ── Sweep history ───────────────────────────────────────────────────────────
  'history.title':           'Sweep History',
  'history.subtitle':        'All sweep runs — {n} total',
  'history.totalPostsSeen':  '📬 Total Posts Seen',
  'history.totalLeads':      '🎯 Total Leads Found',
  'history.totalCost':       '💡 Total AI Cost',
  'history.manual':          'Manual',
  'history.scheduler':       'Scheduler',
  'history.completed':       '✓ Completed',
  'history.failed':          '✗ Failed',
  'history.partial':         '⚠ Partial',
  'history.running':         '⟳ Running',
  'history.noSweeps':        'No sweeps yet — run one to see history',

  // ── Login ────────────────────────────────────────────────────────────────────
  'login.title':              'Pulseem Lead Radar',
  'login.signIn':             'Sign in to your account',
  'login.smsVerification':    'SMS verification',
  'login.emailVerification':  'Email verification',
  'login.email':              'Email',
  'login.password':           'Password',
  'login.signingIn':          'Signing in…',
  'login.signInBtn':          'Sign In',
  'login.captchaRequired':    'Please complete the CAPTCHA',
  'login.invalidCredentials': 'Invalid email or password',
  'login.otpSentPhone':       'A 6-digit code was sent to your phone. Enter it below to complete sign-in.',
  'login.otpSentEmail':       'A 6-digit code was sent to {email}. Enter it below to complete sign-in.',
  'login.verificationCode':   'Verification Code',
  'login.verifying':          'Verifying…',
  'login.verifyBtn':          'Verify Code',
  'login.backToLogin':        'Back to login',
  'login.resendIn':           'Resend in {n}s',
  'login.resend':             'Resend code',
  'login.tooManyAttempts':    'Too many attempts. Please log in again.',
  'login.serverError':        'Could not connect to server',
  'login.resendError':        'Could not resend code',

  // ── Verify page ──────────────────────────────────────────────────────────────
  'verify.title':           'Welcome to Lead Radar',
  'verify.subtitle':        'Set up your name and password to get started',
  'verify.accountReady':    'Account ready!',
  'verify.canNowSignIn':    'You can now sign in with your email and password.',
  'verify.goToLogin':       'Go to Login',
  'verify.yourName':        'Your Name',
  'verify.namePlaceholder': 'First and last name',
  'verify.password':        'Password',
  'verify.passwordPlaceholder': 'Min 10 chars, 1 uppercase, 1 number',
  'verify.confirmPassword': 'Confirm Password',
  'verify.settingUp':       'Setting up account…',
  'verify.createAccount':   'Create Account',
  'verify.enterName':       'Please enter your name',
  'verify.passwordMismatch':'Passwords do not match',
  'verify.invalidLink':     'Invalid or expired link',
  'verify.serverError':     'Could not connect to server',

  // ── Users ────────────────────────────────────────────────────────────────────
  'users.title':          'Users',
  'users.otpMethod':      'OTP Method:',
  'users.otpEmail':       '✉️ Email',
  'users.otpSms':         '📱 SMS',
  'users.inviteNew':      'Invite New User',
  'users.emailPlaceholder':'Email address',
  'users.admin':          'Admin',
  'users.sendInvite':     'Send Invite',
  'users.editUser':       'Edit User',
  'users.name':           'Name',
  'users.phone':          'Phone',
  'users.fullName':       'Full name',
  'users.phoneNumber':    'Phone number',
  'users.setPassword':    'Set Password',
  'users.newPassword':    'New password',
  'users.setPasswordBtn': 'Set Password',
  'users.roleAdmin':      'Admin',
  'users.roleUser':       'User',
  'users.verified':       '✓ Verified',
  'users.pending':        '⏳ Pending',
  'users.editBtn':        '✏ Edit',
  'users.removeAdmin':    'Remove Admin',
  'users.makeAdmin':      'Make Admin',
  'users.deleteBtn':      'Delete',
  'users.otpSetTo':       'OTP method set to {method}',
  'users.inviteSent':     'Invite sent to {email}',
  'users.updated':        'User updated',
  'users.deleted':        'User deleted',
  'users.confirmDelete':  'Delete user {email}?',
  'users.passwordUpdated':'Password updated for {email}',

  // ── App-level ────────────────────────────────────────────────────────────────
  'app.sweepComplete':   '✅ Sweep complete — {n} new leads!',
  'app.sweepInProgress': 'Sweep already in progress',
  'app.sweepFailed':     'Sweep failed: {msg}',

  // ── Language toggle ──────────────────────────────────────────────────────────
  'lang.he': 'עברית',
  'lang.en': 'EN',
};
